export const IMAGES = {
  heroEvening: 'https://cdn.magicpatterns.com/patterns/generated-images/15e08c8a-a494-4700-a9b5-21cf3abe39aa.jpg',
  bakerSourdough: 'https://cdn.magicpatterns.com/patterns/generated-images/11881659-4284-4752-8ce5-56439e00c8d1.jpg',
  coffeeSteam: 'https://cdn.magicpatterns.com/patterns/generated-images/2d39ae6b-1190-4f3e-a94d-054140638faf.jpg',
  tableCandlelight: 'https://cdn.magicpatterns.com/patterns/generated-images/e2a2da3a-b1f1-4c6e-9b1c-980e29940562.jpg',
  peopleLaughing: 'https://cdn.magicpatterns.com/patterns/generated-images/478e1add-8a86-4c2d-9fbd-69c95f638067.jpg',
  ingredients: 'https://cdn.magicpatterns.com/patterns/generated-images/e3835e73-b6e3-462a-b7fd-0630f4ddbf9a.jpg',
  cheeseCharcuterie: 'https://cdn.magicpatterns.com/patterns/generated-images/6e45c36e-5349-42b8-a31b-caf183124798.jpg',
  dessertTable: 'https://cdn.magicpatterns.com/patterns/generated-images/8fc743b5-2ac3-4a58-8c38-642530320605.jpg',
  foodTruck: 'https://cdn.magicpatterns.com/patterns/generated-images/3f0a31e2-d5a8-4733-be03-12c2e24e3578.jpg',
  chefPlating: 'https://cdn.magicpatterns.com/patterns/generated-images/eb3d836c-650b-45a4-9ab8-2b946d2a1f10.jpg',
  businessBakery: 'https://cdn.magicpatterns.com/patterns/generated-images/8303ae1b-9d0f-45da-b556-99c68efa3216.jpg',
  businessCafe: 'https://cdn.magicpatterns.com/patterns/generated-images/a6838bc0-86bb-4958-947c-2485af202a41.jpg',
  businessCatering: 'https://cdn.magicpatterns.com/patterns/generated-images/80869bd4-ba6a-4339-903f-b0cce001e470.jpg',
  galleryCinnamon: 'https://cdn.magicpatterns.com/patterns/generated-images/264b58b6-1c66-481c-9dc4-a443e6930eeb.jpg',
  galleryCake: 'https://cdn.magicpatterns.com/patterns/generated-images/96991e69-59d8-42b1-a2ff-3d943c1f0a9d.jpg',
  gallerySourdough: 'https://cdn.magicpatterns.com/patterns/generated-images/0c664b63-8d57-4f98-a722-f14bd09f5a50.jpg',
  galleryCoffee: 'https://cdn.magicpatterns.com/patterns/generated-images/8b1aea01-7003-4539-af32-7d71f1ddddf8.jpg',
  galleryCheeseboard: 'https://cdn.magicpatterns.com/patterns/generated-images/8f629388-dc39-4d79-b729-ab4de65908c1.jpg',
  galleryDelibox: 'https://cdn.magicpatterns.com/patterns/generated-images/65d70530-8847-48ba-bca4-19be707e197e.jpg',
  galleryPastry: 'https://cdn.magicpatterns.com/patterns/generated-images/eebd77e7-cfe4-4b68-804b-72efaefe699e.jpg',
} as const;

export const OCCASIONS: string[] = [
  'Företagsevent', 'Konferenser', 'Frukostmöten', 'Kickoffer', 'Bröllop',
  'Studentfiranden', 'Födelsedagar', 'Dop', 'Jubileum', 'After Work',
  'Invigningar', 'Vernissager', 'Sommarfester', 'Julbord', 'Mingel',
  'Privatmiddagar', 'Afternoon Tea', 'Fika till kontoret', 'Catering till större sällskap',
  'Delikatesslådor', 'Presentboxar', 'Vin- och matprovningar',
];

export const CATEGORIES: string[] = [
  'Catering', 'Bagerier', 'Konditorier', 'Specialkaffe', 'Dryck',
  'Delikatesser', 'Ost & chark', 'Tårtor', 'Dessertbord', 'Frukost',
  'Lunch', 'Bufféer', 'Food Trucks', 'Privatkockar', 'Eventkoncept',
  'Lokala producenter', 'Säsongsprodukter',
];

export interface Product {
  id: string;
  name: string;
  category: string;
  image: string;
  businessSlug: string;
  businessName: string;
}

export interface Business {
  slug: string;
  name: string;
  place?: string;
  services: string;
  description: string[];
  cover: string;
  products: Product[];
  perfectFor: string[];
  status?: 'active' | 'coming-soon';
  contact: {
    address: string;
    email: string;
    instagram: string;
  };
}

export const BUSINESSES: Business[] = [
  {
    slug: 'lilla-verket',
    name: 'Lilla Verket',
    place: 'Växjö',
    services: 'Mackverk · Ost & Chark Deli · Hantverksbak · Dryckverk',
    description: [
      'Lilla Verket är en plats där mat, vin och människor möts. Här står det lilla extra alltid i centrum – från noggrant utvalda råvaror och hantverksbakade bröd till charkuterier, ostar, naturviner och säsongsbetonade rätter.',
      'Oavsett om du planerar en intim middag, ett företagsevent eller vill bjuda på något som verkligen imponerar erbjuder Lilla Verket catering och delikatesser med samma känsla som restaurangen.',
    ],
    cover: 'https://cdn.magicpatterns.com/uploads/siv1okUNAkxhCZsd7Pwxbr/35677327-8D71-4B0C-8305-E02C836CAB8C_2.jpg',
    contact: {
      address: 'Storgatan 12, 352 31 Växjö',
      email: 'hej@lillaverket.se',
      instagram: '@lilla.verket',
    },
    products: [
      { id: 'lv-1', name: 'Beet & Bleat Macka', category: 'Mackverk', image: 'https://cdn.magicpatterns.com/uploads/uUGsKDQ9ZuyruUBxqGxjuF/749403242_17925808158367125_8423757437317615676_n..jpg', businessSlug: 'lilla-verket', businessName: 'Lilla Verket' },
      { id: 'lv-2', name: 'Matcha Cookies', category: 'Hantverksbak', image: 'https://cdn.magicpatterns.com/uploads/x9G91wUGgW4PeT1pdNuVpb/551860788_17884842120367125_8041553542335615803_n..jpg', businessSlug: 'lilla-verket', businessName: 'Lilla Verket' },
      { id: 'lv-3', name: 'Säsongens Semla', category: 'Säsongsbak', image: 'https://cdn.magicpatterns.com/uploads/nwSkfZUGjhD9mnFrUAiFDX/636747346_17901826836367125_4908737376646108513_n..jpg', businessSlug: 'lilla-verket', businessName: 'Lilla Verket' },
      { id: 'lv-4', name: 'Croissant', category: 'Fika', image: 'https://cdn.magicpatterns.com/uploads/fV4bcFArGpq3Z9HPPZwC5X/586983853_17892207624367125_8566069967174582859_n..jpg', businessSlug: 'lilla-verket', businessName: 'Lilla Verket' },
    ],
    perfectFor: ['Företagsevent', 'Konferenser', 'Vinmingel', 'Bröllop', 'Studentfiranden', 'Jubileum', 'Privatmiddagar', 'Ost- och charkbord', 'Kvällsevent'],
  },
  {
    slug: 'top-notch-bakery',
    name: 'Top Notch Bakery',
    services: 'Surdegbröd · Bakelser · Tårtor · Exemplarisk mat · Hantverk',
    description: [
      'Top Notch Bakery är ett prisbelönt hantverksbageri där allt börjar med riktigt bra råvaror och tid. Här bakas surdegsbröd, viennoiserier, bullar och bakverk från grunden – varje dag.',
      'För företag och privatpersoner erbjuder Top Notch Bakery allt från frukostleveranser och fikakorgar till dessertbord och nybakat bröd för större tillställningar.',
      'När du vill bjuda på fika som gästerna faktiskt kommer ihåg är Top Notch Bakery ett självklart val.',
    ],
    cover: 'https://cdn.magicpatterns.com/uploads/caju5vU6ZxpU7hP5vvMVTb/598180901_18089042921511062_8692022983549048154_n..jpg',
    contact: {
      address: 'Bagerigatan 4, 352 34 Växjö',
      email: 'order@topnotchbakery.se',
      instagram: '@top.notch.bakery',
    },
    products: [
      { id: 'tn-1', name: 'Jordgubbsbakelse', category: 'Bakelser', image: 'https://cdn.magicpatterns.com/uploads/foff1feghzmgrktPEHa3kJ/479502353_18054317555511062_1164978928810660445_n..jpg', businessSlug: 'top-notch-bakery', businessName: 'Top Notch Bakery' },
      { id: 'tn-2', name: 'Hjärtmunkar', category: 'Munkar', image: 'https://cdn.magicpatterns.com/uploads/gRAaespq4UiwTDwNQfiS9H/477483114_18054317570511062_6256980915667201895_n..jpg', businessSlug: 'top-notch-bakery', businessName: 'Top Notch Bakery' },
      { id: 'tn-3', name: 'Rocky Road', category: 'Konfektyr', image: 'https://cdn.magicpatterns.com/uploads/tz597xEfsMcFCP8sLSvn6Q/511454343_18069234947511062_5082887141267518271_n..webp', businessSlug: 'top-notch-bakery', businessName: 'Top Notch Bakery' },
      { id: 'tn-4', name: 'Handgjorda Praliner', category: 'Praliner', image: 'https://cdn.magicpatterns.com/uploads/daughdt1HiFyyZXqxjobkZ/474625572_18054200534511062_5330084380239050637_n..webp', businessSlug: 'top-notch-bakery', businessName: 'Top Notch Bakery' },
      { id: 'tn-5', name: 'Banoffee Bullar', category: 'Specialbullar', image: 'https://cdn.magicpatterns.com/uploads/rYWb74tCJKh1KKKYkCV9zi/475254364_18052295996511062_1534074201207197451_n..jpg', businessSlug: 'top-notch-bakery', businessName: 'Top Notch Bakery' },
      { id: 'tn-6', name: 'Matig Sallad', category: 'Lunch', image: 'https://cdn.magicpatterns.com/uploads/sK8V4Ra5SJVuTmtUd1G3ue/621744886_17977584278806262_511352703514262922_n..webp', businessSlug: 'top-notch-bakery', businessName: 'Top Notch Bakery' },
    ],
    perfectFor: ['Frukostmöten', 'Kontorsfika', 'Konferenser', 'Event', 'Bröllop', 'Student', 'Dessertbord', 'Presenter', 'Helgfrukostar'],
  },
  {
    slug: 'askelyckans-konditori',
    name: 'Askelyckans Konditori',
    place: 'Växjö',
    services: 'Klassiskt konditori · Äkta hantverk · Traditionellt fika av högsta klass',
    description: [
      'Askelyckans Konditori är ett av Växjös mest uppskattade konditorier med lång tradition av genuint hantverk. Här möts klassiska recept och moderna smaker i allt från tårtor och bakelser till småkakor och festbakverk.',
      'Oavsett om du firar ett bröllop, en födelsedag eller vill bjuda kollegorna på något extra finns ett sortiment som passar både små och stora tillfällen.',
    ],
    cover: 'https://cdn.magicpatterns.com/uploads/w5ruAv5pxeKQSGAXQnEF1a/726427019_18603365614048144_8862990606493944039_n..jpg',
    contact: {
      address: 'Konditorivägen 1, 352 35 Växjö',
      email: 'info@askelyckan.se',
      instagram: '@askelyckanskonditori',
    },
    products: [
      { id: 'ak-1', name: 'Hantverksgelato', category: 'Gelato', image: 'https://cdn.magicpatterns.com/uploads/nkmTMH1r71BZcEf1YUhNFH/662380167_18584843452048144_6250819118431865117_n..webp', businessSlug: 'askelyckans-konditori', businessName: 'Askelyckans Konditori' },
      { id: 'ak-2', name: 'Belgiska Våfflor', category: 'Våfflor', image: 'https://cdn.magicpatterns.com/uploads/iwg9L6u4YFL9JVJsH3PWU6/655877909_18579376231048144_655921968418519016_n..jpg', businessSlug: 'askelyckans-konditori', businessName: 'Askelyckans Konditori' },
      { id: 'ak-3', name: 'Klassisk Smörgåstårta', category: 'Smörgåstårtor', image: 'https://cdn.magicpatterns.com/uploads/ugRdgu29ck9LBaKRyhJGUu/495411000_18507168892048144_5595546597522200721_n..webp', businessSlug: 'askelyckans-konditori', businessName: 'Askelyckans Konditori' },
      { id: 'ak-4', name: 'Jordgubbstårta', category: 'Festtårtor', image: 'https://cdn.magicpatterns.com/uploads/w5ruAv5pxeKQSGAXQnEF1a/726427019_18603365614048144_8862990606493944039_n..jpg', businessSlug: 'askelyckans-konditori', businessName: 'Askelyckans Konditori' },
    ],
    perfectFor: ['Bröllop', 'Födelsedagar', 'Dop', 'Student', 'Jubileum', 'Företagsfika', 'Tårtor', 'Dessertbord', 'Högtider'],
  },
  {
    slug: 'lilla-lunch-verket',
    name: 'Lilla Lunch Verket',
    services: 'Välgjorda luncher · Säsongsbetonade råvaror · Moderna lunchlösningar',
    description: [
      'Lilla Lunch Verket är nästa kapitel i familjen. Med fokus på välgjorda luncher, säsongsbetonade råvaror och samma kompromisslösa kvalitet som övriga verksamheter kommer Lilla Lunch Verket erbjuda moderna lunchlösningar för företag, möten och event.',
      'Från färdiga lunchpaket till större cateringlösningar – alltid med smak, kvalitet och hantverk i fokus.',
    ],
    cover: 'https://cdn.magicpatterns.com/uploads/sxdVzvmz448g1P95n5MXLa/722858410_18374176471207415_9088704107144204814_n..jpg',
    contact: {
      address: 'Storgatan 12, 352 31 Växjö',
      email: 'lunch@lillaverket.se',
      instagram: '@lilla.lunch.verket',
    },
    products: [
      { id: 'llv-1', name: 'Asiatisk Nudelsallad', category: 'Lunchskålar', image: 'https://cdn.magicpatterns.com/uploads/npn7Efua1xZnGpupdWPMk4/471247599_18305715730207415_4466171523025485922_n..jpg', businessSlug: 'lilla-lunch-verket', businessName: 'Lilla Lunch Verket' },
      { id: 'llv-2', name: 'Säsongens Råvaror', category: 'Säsongsmenyer', image: IMAGES.ingredients, businessSlug: 'lilla-lunch-verket', businessName: 'Lilla Lunch Verket' },
      { id: 'llv-3', name: 'Cateringbuffé', category: 'Catering', image: IMAGES.businessCatering, businessSlug: 'lilla-lunch-verket', businessName: 'Lilla Lunch Verket' },
      { id: 'llv-4', name: 'Frukostbägare', category: 'Lunchlådor', image: IMAGES.galleryDelibox, businessSlug: 'lilla-lunch-verket', businessName: 'Lilla Lunch Verket' },
    ],
    perfectFor: ['Företagsluncher', 'Mötesluncher', 'Catering', 'Bufféer', 'Sallader', 'Smörgåsar', 'Lunchlådor', 'Säsongsmenyer'],
    status: 'coming-soon',
  },
];
